import { useNavigate } from 'react-router';
import { INCOME_PROOF, WAITING } from 'Router/routes';
import { useBudgetQuery } from 'hooks/webapi';
import {
  useBudgetMutation,
  useBudgetPSDQuery,
} from 'hooks/webapi/client/useBudget';

const useAdjustIncome = () => {
  const navigate = useNavigate();

  const { data: clientBudgetInfo, isLoading: isBudgetInfoLoading } =
    useBudgetQuery(true);
  const { data: clientBudgetPsd, isLoading: isBudgetPsdLoading } =
    useBudgetPSDQuery(true);
  const { mutateAsync: postClientBudget, isPending } = useBudgetMutation();

  const isLoading = isBudgetInfoLoading || isBudgetPsdLoading;

  const handleContinue = async () => {
    if (
      !clientBudgetPsd ||
      !clientBudgetInfo ||
      clientBudgetPsd.monthlyIncome === undefined ||
      clientBudgetInfo.monthlyExpenses === undefined ||
      clientBudgetInfo.numberOfEmployedHouseholdMembers === undefined ||
      clientBudgetInfo.numberOfHouseholdMembers === undefined
    ) {
      return;
    }

    try {
      await postClientBudget({
        ...clientBudgetInfo,
        monthlyIncome: clientBudgetPsd.monthlyIncome,
      });

      navigate(WAITING);
    } catch {
      // Error is logged and shown to the user by useBudgetMutation
    }
  };

  const handleUpload = () => {
    navigate(INCOME_PROOF);
  };

  return {
    clientBudgetInfo,
    clientBudgetPsd,
    isLoading,
    isPending,
    handleContinue,
    handleUpload,
  };
};

export default useAdjustIncome;
